<template>
	<div>
		<span class="go-index" @click="pageTo()">返回</span>

		<div class="order-label">
			<span @click="chooseLabel(1);" :class="span_active==1?'span_active':''">待支付</span>
		</div>
		<div class="order-label">
			<span @click="chooseLabel(2);" :class="span_active==2?'span_active':''">待发货</span>
		</div>
		<div class="order-label">
			<span @click="chooseLabel(3);" :class="span_active==3?'span_active':''">待收货</span>
		</div>
		<div class="order-label">
			<span @click="chooseLabel(5);" :class="span_active==5?'span_active':''">待评价</span>
		</div>
		<div class="order-label">
			<span @click="chooseLabel(7);" :class="span_active==7?'span_active':''">售后</span>
		</div>

		<!-- 根据状态区分 -->
		<div class="scroll-list" style="clear: both;">

			<div class="order-list" v-for="(item,index) in order_list" :key="index">

				<div style="font-size: 0.5rem;border-bottom: 1px solid rgb(239, 239, 239); padding-bottom: .3rem; ">

					<span>订单号： {{item.order_no}}</span>

					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 1">待付款</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 2">待发货</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 3">待收货</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 6">交易完成</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 7">售后中</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 8">交易关闭</span>
					<span style="float: right;margin-right: 0.5rem;color: #ff9d8f;" v-if="item.order_status == 4">交易取消</span> 
					
				</div>

				<div class="order-item" v-for="(item2,index2) in item.order_item" :key="index2">
					<img @click="pageTo('/goods?gid=' + item2.goods_id)" :src="item2.goods_image" />
					<div style="padding-left: 1rem;width: 6rem; font-size: 0.5rem;height: 2rem;float: left;">
						<span style="" @click="toOrder(item.order_id)">{{item2.goods_name}}</span>
					</div>
					<div
						style="margin-right: 0.5rem; width: 3rem; font-size: 0.5rem;height: 2rem;float: right;text-align: right;">
						<span>￥{{item2.goods_price}}</span><br>
						<span>x{{item2.goods_num}}</span>
					</div>

				</div>

				<div class="btn-op">实付款￥ {{item.order_fee}}</div>

				<div class="btn-op" v-if="item.order_status == 1">
					<span class="btn-white">取消订单</span>
					<span class="btn-red" @click="toPayment(item.order_id, item.order_fee)">去支付</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 2">
					<span class="btn-white">申请退款</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 3">
					<span class="btn-white">查看物流</span>
					<span class="btn-white">申请退款</span>
					<span class="btn-red">确认收货</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 6">
					<span class="btn-white">再来一单</span>
					<span class="btn-white">申请售后</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 7">
					<span class="btn-white">取消售后</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 8">
					<span class="btn-white">再来一单</span>
				</div>
				<div class="btn-op" v-if="item.order_status == 4">
					<span class="btn-white">再来一单</span>
				</div>
			</div>

		</div>

		<!-- 组件使用 -->
		<foot />
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.btn-op 
	{
		clear: both;
		margin-right: 0.5rem;
		font-size: 0.5rem;
		text-align: right;
	}

	.btn-red {
		display: inline-block; 
		margin: 0.5rem 0rem 0.5rem 0.25rem;

		font-size: .5rem;
		color: #FFFFFF;
		text-align: center;

		height: 1rem;
		width: 4rem;
		border-radius: 1rem;

		line-height: 1rem;

		background-color: #e60012;;
	}

	.btn-white {
		display: inline-block;

		margin: 0.5rem 0.25rem;

		font-size: .5rem;
		color: black;
		text-align: center;

		height: 1rem;
		width: 4rem;
		border: 1px solid lightgrey;
		border-radius: 1rem;

		line-height: 1rem;
	}

	.order-label {
		width: 20%;
		text-align: center;
		float: left;
		font-size: 0.8rem;
	}

	.order-label>span {
		display: inline-block;
		/* width: 50%; */
		margin: 1rem auto 0.5rem auto;
		padding: 0.4rem 0;
		color: #bababa;
		border: 0;
	}

	.order-label .span_active {
		color: #e60012;
		border-bottom: 1px solid #e60012;
	}

	.order-list {
		box-shadow: 0px 0px .3rem #ccc;
		width: 90%;
		margin: 0rem auto;
		padding: .5rem .5rem;
		clear: both;
		border-radius: 0.5rem;
	}

	.order-item {
		margin: 0.5rem auto;
		clear: both;
	}

	.order-item img {
		display: block;
		float: left;
		width: 4rem;
		height: 4rem;
		border-radius: 0.5rem;
		margin-bottom: .5rem;
	}

	/* .order-list li div{
    width: calc(100% - 5rem);
    float: left;
    margin:0.8rem auto 0 auto;
    font-size: .8rem;
} */
	/* .order-list li::after{
    content: "";
    display: block;
    clear: both;
} */
</style>
<script>
	// 组件引入
	import sy from '@/sy';
	import syalert from '@/components/syalert.vue';
	import foot from '@/components/foot.vue';

	export default {
		components: {
			foot,
			syalert,
		},
		data() {
			return {
				order_list: [],
				page: {
					on: true, // 可以获取 信息
					page: 0
				},

				span_active: 0,
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			chooseLabel: function(act) {
				if (this.span_active !== act) {
					this.span_active = act;
					this.initPage();
				}
			},
			// 订单详情
			toOrder(oid)
			{
				this.$router.push('/order?oid=' + oid);
			},

			// 支付订单
			toPayment(oid, fee)
			{
				this.$router.push('/order/payment?oid=' + oid + '&fee=' + fee );
			},
			// 取消订单
			cancelOrder()
			{
				
			},
			// 申请售后
			applyRepair()
			{
				
			},
			// 申请退款
			applyRefund()
			{
				
			},

			// 复位加载 rest
			initPage: function() {
				this.page = {
					on: true, // 可以获取 信息
					page: 0,
				};
				this.order_list = [];
				this.getList();
			},
			getList: function() {
				if (this.page.on === false) {
					return false;
				}

				this.page.on = false;
				this.page.page++;

				console.log('页码:', this.page.page);

				// 使用案例
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Order/List',
					data: {
						page:   this.page.page,
						active:	this.span_active,
					},
					success: function(res)
					{
						$_this.page.on = true;

						let data = res.data
						let i = 0;
						for (let k in data)
						{
							i++;
							$_this.order_list.push(data[k]);
						}
						if (i < 10)
						{
							$_this.page.on = false; // 数量不足时也关掉
						}
					}
				});
			},
			scroll_event: function() {
				if (document.getElementsByClassName("scroll-list").length > 0) {
					// 相当于剩余高度
					let uh = document.getElementsByClassName("scroll-list")[0].clientHeight;
					if (uh - window.scrollY - window.innerHeight < 20) {
						this.getList();
					}
				}
			},
		},
		created() {
			// 确定活跃 
			let act = this.$router.currentRoute.query.act;

			this.chooseLabel(act); // 存储好
		},
		mounted() {},
		// // 配合缓存使用
		// beforeRouteEnter(to, from, next) {
		//     console.log('to')
		//     console.log(to)
		//     console.log('from')
		//     console.log(from)
		//     console.log(next)
		//     console.log(from.path) //  || from.path == "/orderInfo"
		//     if (from.path == "/meet" ) {
		//         to.meta.isMeet = true;
		//     } else {
		//         to.meta.isMeet = false;
		//     }
		//     to.meta.keepAlive = true
		//     next();
		// },
		activated() {
			sy.log('[页面]-> ' + this.$route.name);

			// 启动监听滑动
			console.log('启动监听滑动');

			// 监听滚动
			window.addEventListener("scroll", this.scroll_event);

			// 初次加载
			if (this.page.page === 0) {
				console.log('初次加载');
				this.initPage();
			}
		},
		deactivated() {
			window.removeEventListener("scroll", this.scroll_event);
			console.log('deactivated')
		},
	}
</script>